import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SiteUnavailable from '../views/SiteUnavailable.vue'
import { loadSiteContext } from '../utils/site-context'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/site-unavailable',
    name: 'site-unavailable',
    component: SiteUnavailable
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('../views/apply.vue')
  },
  {
    path: '/submit',
    name: 'submit',
    component: () => import('../views/submit.vue')
  },
  {
    path: '/cards',
    name: 'cards',
    component: () => import('../views/cards.vue')
  },
  {
    path: '/modifly',
    name: 'modifly',
    component: () => import('../views/modifly.vue')
  },
  {
    path: '/assess',
    name: 'assess',
    component: () => import('../components/assess.vue')
  },
  // {
  //   path: '/assessed',
  //   name: 'assessed',
  //   component: () => import('../components/assessed.vue')
  // },
  {
    path: '/scratchGui',
    name: 'scratchGui',
    component: () => import('../components/scratchGui.vue')
  },
  {
    path: '/blank',
    name: 'blank',
    component: () => import('../components/blank.vue')
  },
  {
    path: '/revisePassword',
    name: 'revisePassword',
    component: () => import('../components/revisePassword.vue')
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'site-unavailable') return next()
  try {
    const site = await loadSiteContext()
    if (site.mode === 'bound') {
      if (to.query.matchId) {
        const query = { ...to.query }
        delete query.matchId
        return next({ path: to.path, query, hash: to.hash, replace: true })
      }
      return next()
    }
    const matchId = to.query.matchId || from.query.matchId
    if (matchId && !to.query.matchId) {
      return next({ path: to.path, query: { ...to.query, matchId }, hash: to.hash, replace: true })
    }
    next()
  } catch (error) {
    next({ name: 'site-unavailable', query: { reason: '该赛事域名未登记，或赛事服务暂时不可用。' }, replace: true })
  }
})

export default router
